import React from "react";
import "./info.css";
import { useHistory } from "react-router-dom";
import Footer from "../Footer"; 


export default function Info() {
  const history = useHistory();

  return (
    <div className="info-page" dir="rtl">
        
      <img src="/icons/modle.png" alt="" className="bg-art" aria-hidden="true" />
    <img src="/icons/bg-art-back.png" alt="" className="bg-art-back" aria-hidden="true" />
      

    <img src="/icons/back_circle_green_right.png" alt="" className="decor decor-tr" />
    <img src="/icons/back_circle_green_left.png" alt="" className="decor decor-tl" />
    <img src="/icons/back_circle_green_bottom.png" alt="" className="decor decor-bottom" />



  <header className="topbar">
  <div className="brand-wrap">
    <img src="/icons/black_green_circle_logo.png" alt="heyi" className="brand-logo" />
    <img src="/icons/Line_w.png" alt="" className="brand-line" aria-hidden="true" />
  </div>

  <nav className="topbar-actions">
    {/* גרסה עם קישור רגיל */}
    <a className="btn-login" href="/sign-in" aria-label="התחבר">התחבר</a>

    {/* אם אתה עם React Router:
    import { useNavigate } from "react-router-dom";
    ואז תשתמש ב:
    <button className="btn-login" onClick={() => navigate('/login')} aria-label="התחבר">התחבר</button>
    */}
  </nav>
  </header>

      <main className="page-body">

      {/* HERO */}
      <section className="hero">
        <img src="/icons/text_logo.png" alt="HEY I" className="hero-title" />
        <img src="/icons/photos_in_moment.png" alt="כל התמונות אצלך בנייד תוך רגע" className="hero-sub" />
        <p className="hero-desc">
          האורחים שלכם יכולים לקבל את כל התמונות שלהם מהאירוע שלכם באמצעות זיהוי פנים, נשמע טוב?
        </p>
        <button className="btn-cta" onClick={() => history.push("/contact")}>צרו איתנו קשר</button>
      </section>

      {/* HOW IT WORK */}
      <section className="how">
        <img src="/icons/how it work.png" alt="אתם יכולים לקבל את כל התמונות שלכם מהאירוע באמצעות זיהוי פנים" className="how-img" />
        <div className="arrow">↓</div>

        <div className="how-cards">
          <article className="how-card">
            <h3>איך זה עובד?</h3>
            <p>
              הכי פשוט שבעולם – הצלמים של האירוע מעלים את כל התמונות שלהם לענן של האפליקציה,
              וכך כל אורח יכול לקבל את כל התמונות שהוא מופיע בהן, כן, כל התמונות.
            </p>
          </article>

          <article className="how-card">
            <h3>איך?</h3>
            <p>
              באמצעות זיהוי פנים מתקדם, האורח מעלה תמונה סלפי שלו, והמערכת משווה תווי פנים,
              וכך יודעת בדיוק אילו תמונות שייכות לו.
            </p>
          </article>

          <article className="how-card">
            <h3>זה בטוח?</h3>
            <p>
              כן, ברור. התמונות לא זמינות בחיפוש פתוח, והשימוש במידע נעשה
              אך ורק כדי לאתר ולשלוח את התמונות לבעל הזכות.
            </p>
          </article>
        </div>
      </section>

      {/* PACKAGES */}
      <section className="packages">
            <img src="/icons/most_sell.png" className="badge" />

        <img src="/icons/green-logo.png"  className="packages-logo" />

        <img src="/icons/packages.png"  className="packages-text-img" />

        <div className="info-cards">
  <div className="card">
    <div className="card-head">בסיסית</div>
    <div className="card-body">
      <div className="qty">200 - עד</div>
      <div className="sub">מוזמנים</div>
      <img src="/icons/black_line.png" className="black_line" />
      <div className="price">250 <span>₪</span></div>
    </div>
    <button className="btn-ghost" onClick={() => history.push("/contact")}>רכישה</button>
  </div>

  <div className="card card-featured">
    <div className="card-head">רגילה</div>
    <div className="card-body">
      <div className="qty">400 - עד</div>
      <div className="sub">מוזמנים</div>
      <img src="/icons/black_line.png" className="black_line" />
      <div className="price">350 <span>₪</span></div>
    </div>
    <button className="btn-ghost" onClick={() => history.push("/contact")}>רכישה</button>
  </div>

  <div className="card">
    <div className="card-head">ענקית</div>
    <div className="card-body">
      <div className="qty">400+</div>
      <div className="sub">מוזמנים</div>
      <img src="/icons/black_line.png" className="black_line" />
      <div className="price">450 <span>₪</span></div>
    </div>
    <button className="btn-ghost" onClick={() => history.push("/contact")}>רכישה</button>
  </div>

</div>


      </section>
      </main>

      {/* TESTIMONIALS */}
      {/* <section className="testimonials">
         <img src="/icons/what_customers_says.png" className="testimonials-title" />

        <div className="t-list">
          <button className="nav prev" aria-label="הקודם">‹</button>

          <div className="t-item">
            <img src="images/0N5A4100.jpg" alt="" className="avatar" />
            <div className="name">ליאור ל׳</div>
            <p>
              לא האמנתי כמה תמונות יצאו לי! סוף סוף כל התמונות מרוכזות, בלי לבקש מכל אחד לשלוח.
              שירות אדיר.
            </p>
          </div>

          <div className="t-item">
            <img src="images/0N5A4100.jpg" alt="" className="avatar" />
            <div className="name">ליאור ד׳</div>
            <p>
              כל המשפחה קיבלה תמונות מהרגע. חוסך זמן, מדויק, והכל מעוצב יפה.
              ממליצה בחום.
            </p>
          </div>

          <div className="t-item">
            <img src="images/0N5A4100.jpg" alt="" className="avatar" />
            <div className="name">א׳ ש׳</div>
            <p>
              פתרון מטורף לצלמים – מעלים פעם אחת, הלקוחות מקבלים לבד.
              חסך לנו ים עבודה.
            </p>
          </div>

          <button className="nav next" aria-label="הבא">›</button>
        </div>
      </section> */}

        <Footer /> 

    </div>
    
  );
}
